/**
 * Tabs are rendered in the order they are defined here.
 */
export const QUOTE_LINE_INFO_TABS = {
  COST_OVERVIEW: 'COST_OVERVIEW',
  QUOTE_HISTORY: 'QUOTE_HISTORY',
  PRICE_SEGMENTS: 'PRICE_SEGMENTS',
  DISCOUNT_PRICE_BOOK: 'DISCOUNT_PRICE_BOOK',
  MARKET_PRICE_BOOK: 'MARKET_PRICE_BOOK',
  COST_ESTIMATOR: 'COST_ESTIMATOR',
  ORDER_HISTORY: 'ORDER_HISTORY',
  COST_BREAKS: 'COST_BREAKS',
  LEAD_TIME: 'LEAD_TIME',
  MATCHING_ORDERS_AND_QUOTES: 'MATCHING_ORDERS_AND_QUOTES',
} as const;

export type ConfigurableQuoteLineInfoTab =
  (typeof QUOTE_LINE_INFO_TABS)[keyof typeof QUOTE_LINE_INFO_TABS];

/**
 * These tabs are always included and do not need to be included in any strategy config.
 */
export const ALWAYS_INCLUDED_TABS = {
  MATCHING_ORDERS_AND_QUOTES: QUOTE_LINE_INFO_TABS.MATCHING_ORDERS_AND_QUOTES,
  DEV_COSTS_DEBUG: 'DEV_COSTS_DEBUG',
  DEV_METRICS_VIEW: 'DEV_METRICS_VIEW',
} as const;

/** @allowUnusedExport */
export const ALL_QUOTE_LINE_INFO_TABS = {
  ...QUOTE_LINE_INFO_TABS,
  ...ALWAYS_INCLUDED_TABS,
};

export type QuoteLineInfoTab =
  (typeof ALL_QUOTE_LINE_INFO_TABS)[keyof typeof ALL_QUOTE_LINE_INFO_TABS];

export const QUOTE_LINE_PART_DETAILS_EXTRA_COMPONENTS = {
  PART_COMPLEXITY: 'PART_COMPLEXITY',
} as const;

export type QuoteLinePartDetailsExtraComponent =
  (typeof QUOTE_LINE_PART_DETAILS_EXTRA_COMPONENTS)[keyof typeof QUOTE_LINE_PART_DETAILS_EXTRA_COMPONENTS];

export const QUOTE_PRICE_STRATEGY_BADGE_COLORS = {
  MARGIN: 'teal',
  FIXED: 'orange',
  USER: 'green',
} as const;

export type QuotePriceStrategyBadgeColor =
  (typeof QUOTE_PRICE_STRATEGY_BADGE_COLORS)[keyof typeof QUOTE_PRICE_STRATEGY_BADGE_COLORS];

/**
 * Defines all quote price fields in the consistent display order.
 * This order is used regardless of how fields are defined in individual strategy configurations.
 */
export const QUOTE_PRICE_FIELDS = {
  quantity: 'quantity',
  unitCost: 'unitCost',
  unitVariableCosts: 'unitVariableCosts',
  baseGrossMargin: 'baseGrossMargin',
  priceAdjustmentAmount: 'priceAdjustmentAmount',
  unitPrice: 'unitPrice',
  grossMargin: 'grossMargin',
  contributionMargin: 'contributionMargin',
  leadTimeWeeks: 'leadTimeWeeks',
} as const;

export type QuotePriceField =
  (typeof QUOTE_PRICE_FIELDS)[keyof typeof QUOTE_PRICE_FIELDS];
